import { Heading, Icon, Layout } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import CustomerPortalBox from "../../components/confirmationPage/CustomerPortalBox";
import { useEffect } from "react";
import { trackOnPaymentSuccess } from "../../adobeTracking/trackers";

export const SuccessPage = () => {
    const { t } = useTranslation("confirmationsuccesspage");
    useEffect(() => {
        trackOnPaymentSuccess();
    }, []);

    return (
        <>
            <Layout center>
                <Layout.Item default="3/4" s="1/1" className="u-text-center">
                    <Heading level={1}>{t("header")}</Heading>
                    <Icon name="semantic-checkmark" className="u-mb-small" style={{ color: "#029640" }} />
                    <Heading level={2}>{t("subHeader")}</Heading>
                    <p>{t("text")}</p>
                    <p>{t("text2")}</p>
                </Layout.Item>
            </Layout>

            <CustomerPortalBox />
        </>
    );
};
